import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { OrganizationSettings } from '@/features/organizations/settings'

export const Route = createFileRoute('/_authenticated/_organization/organizations/settings')(
  {
    component: () => (
      <OrganizationSettings>
        <Outlet />
      </OrganizationSettings>
    ),
    beforeLoad: async ({ location }) => {
      // Check role permissions
      await requireRoles(['owner', 'admin'])
      await requireActiveSubscription()
      
      // Redirect to profile if no sub-route
      if (location.pathname.endsWith('/settings')) {
        throw redirect({
          to: '/organizations/settings/profile',
        })
      }
    },
  }
)
